import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { SUPPORTED_FORMATS } from '../utils/imageConverter';

const { FiDownload, FiFile } = FiIcons;

const ImagePreview = ({ originalFile, convertedBlob, targetFormat, onDownload, isConverting }) => {
  const originalUrl = originalFile ? URL.createObjectURL(originalFile) : null;
  const convertedUrl = convertedBlob ? URL.createObjectURL(convertedBlob) : null;

  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  return (
    <motion.div
      initial={{ y: 20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ delay: 0.2 }}
      className="w-full space-y-6"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Original Image */}
        <div className="space-y-3">
          <h3 className="text-lg font-medium text-primary-600">Original</h3>
          <div className="border border-gray-200 rounded-lg p-4 bg-gray-50">
            {originalFile && (
              <>
                {originalFile.type.startsWith('image/') && originalFile.type !== 'image/svg+xml' ? (
                  <img
                    src={originalUrl}
                    alt="Original"
                    className="w-full h-48 object-contain rounded"
                  />
                ) : (
                  <div className="w-full h-48 flex items-center justify-center bg-white rounded">
                    <SafeIcon icon={FiFile} className="text-4xl text-gray-400" />
                  </div>
                )}
                <div className="mt-3 text-sm text-primary-600">
                  <p><strong>Format:</strong> {SUPPORTED_FORMATS[originalFile.type]?.label || 'Unbekannt'}</p>
                  <p><strong>Größe:</strong> {formatFileSize(originalFile.size)}</p>
                </div>
              </>
            )}
          </div>
        </div>

        {/* Converted Image */}
        <div className="space-y-3">
          <h3 className="text-lg font-medium text-primary-600">Konvertiert</h3>
          <div className="border border-gray-200 rounded-lg p-4 bg-gray-50">
            {isConverting ? (
              <div className="w-full h-48 flex items-center justify-center">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"></div>
              </div>
            ) : convertedBlob ? (
              <>
                <img
                  src={convertedUrl}
                  alt="Konvertiert"
                  className="w-full h-48 object-contain rounded"
                />
                <div className="mt-3 space-y-2">
                  <div className="text-sm text-primary-600">
                    <p><strong>Format:</strong> {SUPPORTED_FORMATS[targetFormat]?.label}</p>
                    <p><strong>Größe:</strong> {formatFileSize(convertedBlob.size)}</p>
                  </div>
                  <button
                    onClick={onDownload}
                    className="w-full flex items-center justify-center space-x-2 bg-button text-white px-4 py-2 rounded-md hover:bg-button-hover transition-colors font-medium"
                  >
                    <SafeIcon icon={FiDownload} />
                    <span>Herunterladen</span>
                  </button>
                </div>
              </>
            ) : (
              <div className="w-full h-48 flex items-center justify-center bg-white rounded">
                <p className="text-gray-400">Konvertiertes Bild wird hier angezeigt</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default ImagePreview;